import { cn } from "@/lib/utils";
import { useI18n } from "@/i18n";

const QUOTE_STYLES = {
  draft: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300",
  sent: "bg-sky-100 text-sky-800 dark:bg-sky-950 dark:text-sky-300",
  accepted: "bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300",
  rejected: "bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-300",
  expired: "bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300",
  revised: "bg-violet-100 text-violet-800 dark:bg-violet-950 dark:text-violet-300",
  open: "bg-sky-100 text-sky-800 dark:bg-sky-950 dark:text-sky-300",
  active: "bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300",
  inactive: "bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400",
  ready: "bg-sky-100 text-sky-800 dark:bg-sky-950 dark:text-sky-300",
  finalized: "bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300",
  exported: "bg-indigo-100 text-indigo-800 dark:bg-indigo-950 dark:text-indigo-300",
  validation_error: "bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-300",
  cancelled: "bg-slate-200 text-slate-600 dark:bg-slate-700 dark:text-slate-300",
};

export function StatusBadge({ status, labelKey, testId }) {
  const { t } = useI18n();
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
        QUOTE_STYLES[status] || QUOTE_STYLES.draft
      )}
    >
      {t(labelKey || `status.${status}`)}
    </span>
  );
}
